var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
var SvgResetClock = function SvgResetClock(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    stroke: "#FF9",
    strokeLinecap: "round",
    strokeWidth: 1.667
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M10 17.5a6.667 6.667 0 1 0 0-13.333A6.667 6.667 0 0 0 10 17.5Z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M10 6.667v4.166h3.333M4.167 1.667l-2.5 2.5m14.166-2.5 2.5 2.5"
  }))));
};
export default SvgResetClock;